export type DatapointValueControlVariant = 'TABLE_CELL' | 'LIST_ITEM';

export enum AnnotationControlVariant {
  TableCell = 'TABLE_CELL',
  ListItem = 'LIST_ITEM',
}
